import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IParavetStaffListItem, IParavetStaffListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useParavetOptionsAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [paravetOptions, setParavetOptions] = useState<IParavetStaffListItem[]>([]);
  const [allParavets, setAllParavets] = useState<IParavetStaffListItem[]>([]);

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      const response = await axios.get<IParavetStaffListResponse>(CONFIGURATION_APIS.PARAVET_STAFF_LIST.baseURL, {
        headers: {
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      const paravets = response.data?.data ?? [];
      const activeParavets = paravets.filter((paravet) => paravet?.status?.toUpperCase() === "ACTIVE");
      setAllParavets(paravets);
      setParavetOptions(activeParavets);
      return activeParavets;
    } catch (error) {
      setParavetOptions([]);
      setAllParavets([]);
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        captureError(axiosError);
        if (axiosError.config) {
          sendCurl(axiosError.config["curlCommand"]);
        }
      }
      return [];
    }
  }, [configuration]);

  return { execute, paravetOptions, allParavets };
};
